import { useMemo } from 'react';
import { getUnitCalculationView } from 'utils/accessorials/unitCalculation';

/**
 * Derives the Unit Calculation section's view-model (visibility mode, the
 * read-only calculation method, preview copy, etc.) from an accessorial's
 * config. The derivation is pure (see `getUnitCalculationView`); this hook just
 * memoizes it on the inputs that affect it.
 */
export default function useUnitCalculation({
  rate_type,
  unit_type,
  begin_date_required,
  end_date_required,
  calc_method,
}) {
  return useMemo(
    () =>
      getUnitCalculationView({
        rate_type,
        unit_type,
        begin_date_required,
        end_date_required,
        calc_method,
      }),
    [rate_type, unit_type, begin_date_required, end_date_required, calc_method],
  );
}
